import { render, staticRenderFns } from "./ApiFavUsersTable.vue?vue&type=template&id=7a124d1b&scoped=true"
import script from "./ApiFavUsersTable.vue?vue&type=script&lang=ts"
export * from "./ApiFavUsersTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a124d1b",
  null
  
)

export default component.exports